export enum DateFilterType {
    none = 0,
    withinTheLast = 1,
    moreThan = 2,
    between = 3,
}
